export const isCorrectFileFormat = (file) => {
  return (
    file.name.toLowerCase().endsWith('.xlsx') ||
    file.name.toLowerCase().endsWith('.csv')
  );
};
